<template>
    <!-- Greenhouse Year Space -->
    <v-hover>
        <template v-slot="{ hover }">
            <v-card :elevation="hover ? 6 : 3" :loading="isLoading">
                <slot name="header"></slot>
                <div class="px-3 pt-0">
                    <v-row align="center" class="mx-0">
                        <v-col cols="12">
                            <div id="chart">
                                <apexchart
                                    type="bar"
                                    height="200"
                                    :options="chartOptions"
                                    :series="series"
                                ></apexchart>
                            </div>
                        </v-col>
                    </v-row>
                </div>

                <slot name="footer"></slot>
            </v-card>
        </template>
    </v-hover>
</template>

<script>
import gql from "graphql-tag";
import VueApexCharts from "vue-apexcharts";

export default {
    name: "greeenhouse-planned-space-chart",
    components: { apexchart: VueApexCharts },
    // props: ["greenhouseNodeId", "taskYear"],
    data() {
        return {
            isLoading: false,

            series: [
                {
                    name: "Growing",
                    data: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]
                },
                {
                    name: "Sales",
                    data: [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]
                }
            ],
            chartOptions: {
                chart: {
                    id: "greenhouse-space-chart",
                    type: "bar",
                    height: 200,
                    stacked: true,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false
                    },
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                            this.$emit(
                                "week-selected",
                                config.seriesIndex,
                                config.dataPointIndex + 1
                            );
                        }
                    },
                    animations: {
                        enabled: false
                    }
                },
                xaxis: {
                    // tickPlacement: 'on',
                    type: "numeric",
                    hideOverlappingLabels: true,
                    categories: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42,
                        43,
                        44,
                        45,
                        46,
                        47,
                        48,
                        49,
                        50,
                        51,
                        52,
                        53
                    ]
                },
                yaxis: {
                    labels: {
                        formatter: function(val) {
                            return val.toFixed(0);
                        }
                    },
                    title: {
                        text: "m2"
                    },
                    max: 2000 //default value, will be updated by greenhouse total space
                },
                fill: {
                    opacity: 1
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#00E396", "#FEB018"],
                legend: {
                    position: "top",
                    horizontalAlign: "left",
                    offsetX: 0,
                    offsetY: 0
                }
            }
        };
    },
    computed: {
        // hasPlantColors: function () {
        //     return this.plant.plantColorSet.edges.length > 0;
        // },
        // hasPlantEnvironments: function () {
        //     return this.plant.plantEnvironmentSet.edges.length > 0;
        // },
        // hasPlantPotSizes: function () {
        //     return this.plant.plantPotSizeSet.edges.length > 0;
        // },
        // hasPlantTags: function () {
        //     return this.plant.plantTagSet.edges.length > 0;
        // },
        // sortedPotSizes: function () {
        //     var _sorted = this.plant.plantPotSizeSet.edges;
        //     if (_sorted.length > 0) {
        //         _sorted = _sorted.sort((a, b) => {
        //             return a.node.potSize.potSizeCm - b.node.potSize.potSizeCm;
        //         });
        //     }
        //     return _sorted;
        // }
    },
    watch: {
        // greenhouseNodeId() {
        //     // console.log(val);
        //     this.getGreenhousePlannedSpace();
        // },
        // taskYear() {
        //     // console.log(val);
        //     this.getGreenhousePlannedSpace();
        // }
    },
    methods: {
        getGreenhousePlannedSpace(greenhouseNodeId, taskYear, folderID, nullFilter) {
            // console.log(this.greenhouseNodeId, this.taskYear);

            if (!greenhouseNodeId || !taskYear) {
                return;
            }

            this.isLoading = true;

            this.$apollo
                .query({
                    // Query
                    query: gql`
                        query greenhouse(
                            $greenhouse_Id: ID!,
                            $taskYear: Int!, 
                            $planFolder: ID
                            $planFolderIsnull: Boolean
                            ) {
                            greenhouse(id: $greenhouse_Id) {
                                id
                                name
                                greenhousePlannedSpaceSet(taskYear: $taskYear, planFolder: $planFolder, planFolder_Isnull: $planFolderIsnull) {
                                    edges {
                                        node {
                                            id
                                            taskWeek
                                            growthSpaceM2
                                            salesSpaceM2
                                            totalQuantity
                                        }
                                    }
                                }
                                totalSpaceM2
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        greenhouse_Id: greenhouseNodeId,
                        taskYear: taskYear,
                        planFolder: folderID,
                        planFolderIsnull: nullFilter
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    // Result
                    // console.log(response.data);
                    // console.log(response.data.updateSalesOrderNote.salesOrder.note);

                    // console.log(this.chartOptions);

                    if (
                        response.data.greenhouse &&
                        response.data.greenhouse.greenhousePlannedSpaceSet
                    ) {
                        const _growingSpaceArray = this.chartOptions.xaxis.categories.map(
                            item => {
                                const a = response.data.greenhouse.greenhousePlannedSpaceSet.edges.find(
                                    e => {
                                        return e.node.taskWeek == item;
                                    }
                                );

                                return a ? a.node.growthSpaceM2 : 0;
                            }
                        );

                        const _salesSpaceArray = this.chartOptions.xaxis.categories.map(
                            item => {
                                const a = response.data.greenhouse.greenhousePlannedSpaceSet.edges.find(
                                    e => {
                                        return e.node.taskWeek == item;
                                    }
                                );

                                return a ? a.node.salesSpaceM2 : 0;
                            }
                        );

                        // console.log(_growingSpace);
                        // console.log(_salesSpace);

                        var _totalSpaceArray = this.chartOptions.xaxis.categories.map(
                            item => {
                                // console.log(item - 1);

                                return (
                                    _growingSpaceArray[item - 1] +
                                    _salesSpaceArray[item - 1]
                                );
                            }
                        );

                        // _totalSpaceArray.push(
                        //     response.data.greenhouse.totalSpaceM2
                        // );

                        // console.log(_totalSpaceArray);

                        const _maxSeriesValue = Math.max(
                            ..._totalSpaceArray,
                            response.data.greenhouse.totalSpaceM2
                        );

                        // console.log(_maxSeriesValue);

                        this.chartOptions = {
                            ...this.chartOptions,
                            ...{
                                annotations: {
                                    yaxis: [
                                        {
                                            y:
                                                response.data.greenhouse
                                                    .totalSpaceM2, //default value, will be updated by greenhouse total space
                                            borderColor: "#eb4034",
                                            label: {
                                                borderColor: "#eb4034",
                                                style: {
                                                    color: "#fff",
                                                    background: "#eb4034"
                                                },
                                                text: "100%"
                                            }
                                        }
                                    ]
                                }
                            },
                            ...{
                                yaxis: {
                                    labels: {
                                        formatter: function(val) {
                                            return val.toFixed(0);
                                        }
                                    },
                                    title: {
                                        text: "m2"
                                    },
                                    max: _maxSeriesValue //default value, will be updated by greenhouse total space
                                }
                            }
                        };

                        this.series = [
                            { name: "Growing", data: _growingSpaceArray },
                            { name: "Sales", data: _salesSpaceArray }
                        ];
                    }

                    // console.log(this.series);
                    // // add growing space
                    // const growingSpace = response.data.greenhouse.greenhousePlannedSpaceSet.edges.map(
                    //     (item) => {
                    //         return {
                    //             name: "Growing",
                    //             data: [
                    //                 moment(item.node.growthStartDate).isoWeek(),
                    //                 moment(item.node.growthStartDate)
                    //                     .add(item.node.totalGrowthWeeks, "week")
                    //                     .isoWeek()
                    //             ]
                    //         };
                    //     }
                    // );
                })
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isLoading = false;
                });
        }
    }
};
</script>